import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsDeleteUserFromCompanyBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Remove user from a company</div>
          <div className="text">
            Removes the user from a company that they were previously associated with.
          </div>
          <div className="text">
            Why is this endpoint useful? If a user of your application has moved from one
            organization to another or if a user is no longer a part of an organization.
          </div>
          <div className="text">
            Please note that removing a user from a company will result in their votes no longer
            being associated with the company's spend.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: 'The identifier of your company.',
                heading: 'companyID',
                subheading: 'string',
              },
              {
                description: (
                  <p>
                    The unique identifier of the user. This can be found through the{' '}
                    <a href="#retrieve_user">Retrieve User</a> endpoint.
                  </p>
                ),
                heading: 'id',
                subheading: 'string',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">
            Returns "success" if the user was removed. Otherwise an error describing the issue with
            your request.
          </div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/users/remove_user_from_company</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/users/remove_user_from_company"
            body={`-d '{
    "apiKey": "YOUR_API_KEY",
    "companyID": "company1",
    "id": "553c3ef8b8cdcd1501ba123a"}' \\
    -H "Content-Type: application/json"`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">{`"success"`}</Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
